import React from "react";
// Generic, canvas-agnostic icon - safe to share (see CLAUDE.md's reuse list).
export { ArrowRightIcon } from "../StrategyCanvas/StrategyCanvasHelpers";

// The 11 stage milestones the coach dashboard walks through, in the same
// order the backend uses for its "last-non-null milestone wins" stage
// computation (COACH-API.md §2). This is intentionally its own list, not a
// port of Strategy Canvas's STEPS: EXW has 11 milestones where Canvas has 10,
// and unlike Canvas's positional stepDates array, these are looked up by
// `key` against the dashboard row's own `timestamps[]` - see
// ExecutionBlueprintSteps.js. `label` here is only the fallback shown if a
// given timestamp entry doesn't carry its own `label` from the backend.
export const MILESTONES = [
  { key: "SYNTHESIS_STARTED", label: "Execution Blueprint started" },
  { key: "SYNTHESIS_COMPLETED", label: "Strategy Canvas read" },
  { key: "INTERVIEW_STARTED", label: "Interview started" },
  { key: "INTERVIEW_COMPLETED", label: "Interview completed" },
  { key: "CRITIQUE_SUBMITTED", label: "Sent for AI final review" },
  { key: "CRITIQUE_READY", label: "AI final review ready" },
  { key: "CRITIQUE_REVIEW_OPENED", label: "Reviewing suggestions" },
  { key: "SENT_TO_COACH", label: "Sent to you" },
  { key: "REVIEW_SUBMITTED", label: "Review sent to CEO" },
  { key: "LIVE_REVIEW_STARTED", label: "Live review started" },
  { key: "LOCKED", label: "Execution Blueprint locked" },
];

export const TOTAL_MILESTONES = MILESTONES.length;

// Mirrors Strategy Canvas's ProgressBar (StrategyCanvasHelpers.js) but sized
// for 11 segments instead of 10 - the two counts differ (see MILESTONES
// above), so this can't just import Canvas's TOTAL_SEGMENTS-bound version.
// `filled` is clamped defensively since stage_index's 0-vs-1-based convention
// is unconfirmed (docs/execution-blueprint/COACH-API.md §5 #7) - an
// off-by-one there should never render more/fewer segments than exist.
export const ExecutionBlueprintProgressBar = ({ filled = 0 }) => {
  const clamped = Math.max(0, Math.min(filled, TOTAL_MILESTONES));
  const isComplete = clamped >= TOTAL_MILESTONES;
  return (
    <div className="eb-progress">
      {Array.from({ length: TOTAL_MILESTONES }).map((_, index) => {
        const segmentIndex = index + 1;
        const isFilled = segmentIndex <= clamped;
        const isCurrent = !isComplete && segmentIndex === clamped + 1;
        return (
          <div
            key={index}
            className={`eb-progress-segment ${isFilled ? "filled" : ""} ${
              isCurrent ? "current" : ""
            }`}
          />
        );
      })}
    </div>
  );
};
